import React, {Component} from 'react';
import {Jumbotron} from '../components';
import {Grid, Row, Col} from 'react-bootstrap/lib';
import Search from './search';

class Home extends Component {
  render() {
    return (
      <Row>
        <Grid>
          <Jumbotron />
          <Row>
            <Col xs={12}>
              <Search />
            </Col>
          </Row>
        </Grid>
      </Row>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/index.js